/**
 * Нотификации
 */
export default class GeoMapNotification {
  constructor() {
    this.is_max_request_count = false;
  }
}